<template>
  <div
    class="wrapper-report  "
    :style="{
      'z-index': '3'
    }"
  >
    <aha-toggle-tip
      to="accuracy-box"
      :text="$i18nPresenter.t('Average participant accuracy on questions with correct answers')"
    >
    </aha-toggle-tip>
    <aha-toggle-tip
      to="submission-box"
      :text="tooltipGuide"
    >
    </aha-toggle-tip>
    <div class="mx-auto">
      <page-breadcrumb
        :category="breadcrumbsCategory"
        :text="$i18nPresenter.t('Report')"
        :n-level-array="breadcrumbsMultipleLevelArray"
        @clickNLevel="clickBreadcrumbsNLevel"
        isSecondLevelClickable
        @clickSecondLevel="backToPreviousPage()"
        :title="presentation.name"
      />
      <div class="flex flex-col gap-4">
        <!--        info presentation start-->
        <div class="flex w-full wrapper-toolbox justify-between align-middle gap-4">
          <div class="section-info-presentation flex">
            <ListSessions v-if="canUseMultipleSessions && presentation.id" :snapshotInfo="snapshotInfo" />

            <span
              class=" min-w-max flex items-center text-sm md:text-base"
              :content="$i18nPresenter.t('Number of slides')"
              v-aha-tooltip="{ arrow : true }"
              v-if="!canUseMultipleSessions"
            >
              <aha-icon
                class="mr-1 base-color"
                name="slides"
                width="16"
                height="16"
                viewBox="0 0 12 12"
              />
              <span>
                {{ presentation.slideCount }}
              </span>
            </span>

            <div
              :content="$i18nPresenter.t('Presentation creation date and time')"
              v-aha-tooltip="{ arrow : true }"
              class="flex items-center  min-w-max time-box-report"
            >
              <aha-icon
                class="mr-1 base-color"
                name="presentations"
                width="20"
                height="16"
                viewBox="0 0 12 12"
              />

              <div class="font-light text-sm md:text-base">
                <span v-if="canUseMultipleSessions">
                  <aha-formatter
                    :value="selectedSession.updatedAt"
                    type="date"
                    :locale="locale"
                    v-if="selectedSession"
                  />
                </span>
                <span v-else>
                  <span></span>
                  {{ moment(presentation.createdAt).format('DD MMM YYYY, hh:mm A') }}
                </span>
              </div>
            </div>
          </div>
          <div class="grid gap-2 grid-cols-2 md:flex">
            <ContextMenuBase v-if="canShareReportAsLink" class="col-span-2 md:col-auto w-full">
              <template #trigger>
                <aha-antd-button
                  class="md-hidden-report w-full"
                  name="report-share-dropdown-button"
                  v-aha-emit-action
                  :size="'xl'"
                  variant="secondary"
                >
                  <aha-icon
                    height="20"
                    name="link-icon"
                    viewBox="0 0 18 14"
                    class="mr-2"
                  />
                  {{ $i18nPresenter.t('Share') }}
                </aha-antd-button>
                <aha-antd-button
                  class="hidden-report md-flex"
                  name="report-share-dropdown-button"
                  v-aha-emit-action
                  variant="secondary"
                >
                  <aha-icon
                    height="20"
                    name="link-icon"
                    viewBox="0 0 18 14"
                    class="mr-2"
                  />
                  {{ $i18nPresenter.t('Share') }}
                </aha-antd-button>
              </template>
              <template #items>
                <aha-context-menu-item
                  name="share-report-link-button"
                  v-aha-emit-action
                  @click="showShareReportLinkModal = true"
                >
                  <aha-icon
                    height="18"
                    viewBox="0 0 18 20"
                    name="file-text"
                  />
                  <div>{{ $i18nPresenter.t('Share report via link') }}</div>
                </aha-context-menu-item>
                <aha-context-menu-item
                  name="share-slides-link-button"
                  v-aha-emit-action
                  @click="showShareSlidesLinkModal = true"
                >
                  <aha-icon
                    width="20"
                    height="20"
                    viewBox="0 0 14 16"
                    name="presentations"
                  />
                  <div>{{ $i18nPresenter.t('Share slides via link') }}</div>
                </aha-context-menu-item>
              </template>
            </ContextMenuBase>
            <ExportSectionV2 class="hidden flex-1 sm:flex-none sm:order-2 md:flex" />
            <ExportSectionV2
              :size="'xl'"
              class="flex-1 sm:flex-none sm:order-2 md:hidden"
            />
            <aha-antd-button
              :size="'xl'"
              class="bg-white flex-1 sm:flex-none md-hidden-report"
              variant="secondary"
              @click="backToPresentation"
            >
              <aha-icon
                height="18"
                name="edit-outline"
                viewBox="0 0 20 20"
                class="mr-2"
              />
              {{ $i18nPresenter.t('View slides') }}
            </aha-antd-button>
            <aha-antd-button
              class="hidden-report bg-white flex-1 sm:flex-none md-flex"
              variant="secondary"
              @click="backToPresentation"
            >
              <aha-icon
                height="18"
                name="edit-outline"
                viewBox="0 0 20 20"
                class="mr-2"
              />
              {{ $i18nPresenter.t('View slides') }}
            </aha-antd-button>
          </div>
        </div>
        <!-- info presentation end-->
        <!--        desktop 4 grid ipad 2 grid  -->
        <section class="info-section">
          <section class="overal-report-section">
            <div
              class="metric-box"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Total participant',),
              }"
              :content="$i18nPresenter.t('Total number of participants joined')"
              v-aha-tooltip="{ arrow: true }"
              @click="handleTabChange(TABS.PARTICIPANTS)"
            >
              <aha-icon
                name="circle-audience"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-audience-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div
                  v-else-if="!isLoadingReport && reportMetric
                    && reportMetric.totalAudience !== 0 "
                  class="text-metric"
                >
                  {{ (reportMetric && reportMetric.totalAudience || 0 )| formatNumber }}
                </div>
                <div class="text-explain-metric">
                  {{ reportMetric && reportMetric.totalAudience !== 0
                    ? $i18nPresenter.t('Total participants') : $i18nPresenter.t('No participants') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box cursor-auto"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Reactions',),
              }"
              v-aha-tooltip="{
                content: reactionTooltipContent,
                allowHTML: true, arrow: true,
              }"
            >
              <aha-icon
                name="circle-heart"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-heart-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div class="text-metric" v-else-if="!isLoadingReport && !emptyReactions">
                  {{ numberOfReactions }}
                </div>
                <div class="text-explain-metric">
                  {{ emptyReactions
                    ? $i18nPresenter.t('No reactions') : $i18nPresenter.t('Total Reactions') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box"
              name="submission-box"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Avg. submissions',),
              }"
              @click="handleTabChange(TABS.PARTICIPANTS)"
            >
              <aha-icon
                name="circle-submission"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-submission-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div v-else-if="noSubmission" class="text-metric">
                  {{ formatNumberForMetric(reportMetric && reportMetric.averageSubmissionCount ) | formatNumber }}
                </div>
                <div class="text-explain-metric">
                  {{ noSubmission ? $i18nPresenter.t('Avg. submissions') : $i18nPresenter.t('No submissions') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Accuracy',),
              }"
              name="accuracy-box"
              @click="handleTabChange(TABS.PARTICIPANTS)"
            >
              <aha-icon
                name="circle-check-mark"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-check-mark-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="100%"
                    height="20px"
                  />
                </div>
                <div class="text-metric" v-else-if="!isLoadingReport && noAnswer">
                  {{ reportMetric && Math.round(((reportMetric && reportMetric.totalAccuracy) || 0 ) * 100) }} %
                </div>
                <div class="text-explain-metric">
                  {{ noAnswer
                    ? $i18nPresenter.t('Accuracy') : $i18nPresenter.t('No answers') }}
                </div>
              </div>
            </div>
            <div
              class="metric-box"
              @click="handleTabChange(TABS.FEEDBACK)"
              v-hover-intent="{
                onEnter:() => {},
                onExit: () => trackingHereSection('Ratings',),
              }"
              :content="$i18nPresenter.t('Average rating by participants')"
              v-aha-tooltip="{ arrow: true }"
            >
              <aha-icon
                name="circle-star"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <aha-icon
                name="circle-star-color"
                maintainColor
                width="52"
                viewBox="0 0 52 52"
              />
              <div class="flex flex-col gap-1 md:gap-2">
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="150px"
                    height="20px"
                  />
                </div>
                <div
                  v-else-if="!isLoadingReport && totalRatings > 0"
                  class="text-metric flex flex-row justify-start items-center gap-2"
                >
                  {{ avgRating }}
                  <div>
                    <AhaStarRatingView
                      class="flex justify-center"
                      :rate="Number(avgRating)"
                      size="16px"
                    />
                  </div>
                </div>
                <div v-if="isLoadingReport" class="text-metric">
                  <aha-skeleton-loader
                    width="50px"
                    height="20px"
                  />
                </div>
                <div class="text-explain-metric" v-else>
                  {{ totalRatings === 0 ? $i18nPresenter.t('No ratings') : (totalRatings > 1
                    ? $i18nPresenter.t('x ratings', { number: totalRatings })
                    : $i18nPresenter.t('x rating', { number: totalRatings })
                  ) }}
                </div>
              </div>
            </div>
          </section>
          <section class="preview-section">
            <SlidesPreview
              :presentation="presentation"
            ></SlidesPreview>
          </section>
        </section>
        <div class="wrapper-table">
          <aha-multi-tabs
            class="px-4 text-base"
            @onChangeTab="handleTabChange"
            :key="selectedTab"
            :defaultTabIndex="selectedTab"
            :tabTitles="tabNames"
          >
          </aha-multi-tabs>
          <ReportPrivateFeedbackV2
            v-if="selectedTab === TABS.FEEDBACK"
            :oldFeedbacks="privateFeedbacks"
            :newFeedbacks="newPrivateFeedbacks"
          />
          <ListParticipant
            v-if="selectedTab === TABS.PARTICIPANTS"
            @click-audience="handleClickAudience"
          />
          <div v-if="canUseDataMartIndividualReport">
            <SideDrawer
              v-if="showAudienceReportPanel"
              @close="showAudienceReportPanel = false"
            >
              <template #content>
                <IndividualParticipantReport
                  :audienceId="audienceId"
                  :presentation-id="presentationId"
                />
              </template>
            </SideDrawer>
          </div>
        </div>
      </div>
    </div>
    <ShareReportLinkModal
      v-if="showShareReportLinkModal"
      @hide="showShareReportLinkModal = false"
    />
    <ShareSlidesLinkModal
      :presentation="presentation"
      v-if="showShareSlidesLinkModal"
      @hide="showShareSlidesLinkModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// components
import SlidesPreview from '@/components-v2/presentation-report/SlidesPreview.vue'
import ReportPage from '@/components-v2/presentation-report/ReportPage.vue'
import ContextMenuBase from '@/components-v2/common/context-menu/context-menu.base.vue'
import Reactions from '@/components-v2/my-presentations/main-table/Reactions.vue'
import ExportSectionV2 from '@/components-v2/presentation-report/ExportSectionV2.vue'
import IndividualParticipantReport from '@/components-v2/presentation-report/ReportAudienceDetail/IndividualParticipantReport.vue'
import SideDrawer from '@/components-v2/presentation-report/ReportAudienceDetail/SideDrawer.vue'
import { ROUTE_NAMES } from '@/constant/routes'
import ShareReportLinkModal from '@/components-v2/presentation-report/ShareReportLinkModal.vue'
import ShareSlidesLinkModal from '@/components-v2/presentation-report/ShareSlidesLinkModal.vue'
import ListSessions from '@/components-v2/presentation-report/ListSessions.vue'

const TABS = {
  PARTICIPANTS: 0,
  FEEDBACK: 1,
}

export default {
  components: {
    ...ReportPage.components,
    SlidesPreview,
    ExportSectionV2,
    IndividualParticipantReport,
    SideDrawer,
    ContextMenuBase,
    ShareReportLinkModal,
    ShareSlidesLinkModal,
    ListSessions,
  },
  extends: ReportPage,
  data() {
    return {
      showAudienceReportPanel: false,
      showShareReportLinkModal: false,
      showShareSlidesLinkModal: false,
      audienceId: 0,
      presentationId: 0,
      mapTabNames: [
        'participants',
        'feedback',
      ],
      selectedTab: TABS.PARTICIPANTS,
      TABS,
    }
  },
  computed: {
    ...ReportPage.computed,
    ...Reactions.computed,
    ...mapGetters('presentationReport', ['canShareReportAsLink', 'canUseDataMartIndividualReport']),
    ...mapGetters('multipleSessions', ['canUseMultipleSessions', 'selectedSession']),
    tabNames() {
      return [this.tabParticipantsName, this.tabFeedbackName]
    },
    tabParticipantsName() {
      const reportMetric = this.reportMetric?.totalAudience || 0
      const totalAudience = this.$options.filters.formatNumber(reportMetric)
      return `${this.$i18nPresenter.t('Participants')} (${totalAudience})`
    },
    tabFeedbackName() {
      const feedback = this.feedbackList?.length || 0
      const totalFeedback = this.$options.filters.formatNumber(feedback)
      return `${this.$i18nPresenter.t('Feedback')} (${totalFeedback})`
    },
    tooltipGuide() {
      return this.$i18nPresenter.t('Average number of submissions per participant on polls, word clouds, scales, open-ended questions, brainstorming, Q&A')
    },
    emptyReactions() {
      return this.numberOfReactions === 0
    },
    reactionTooltipContent() {
      return this.emptyReactions ? this.$i18nPresenter.t('Total number of reactions from participants') : this.iconTooltipContent
    },
  },
  mounted() {
    this.handleChangeUrlParams()
  },
  methods: {
    ...ReportPage.methods,
    setDefaultTabInEditor() {
      const { tab } = this.$route.query
      this.selectedTab = Number.isNaN(Number(tab)) ? TABS.PARTICIPANTS : Number(tab)
    },
    handleChangeUrlParams() {
      this.presentationId = this.$route?.params?.id
      this.audienceId = this.$route?.params?.audienceId

      if (this.presentationId && this.audienceId) {
        this.showAudienceReportPanel = true
      }
    },
    handleClickAudience(audience) {
      this.$router.push({
        name: ROUTE_NAMES.PRESENTATION_REPORT,
        params: {
          id: this.$route?.params?.id,
          audienceId: audience.audienceId,
        },
      })
      this.handleChangeUrlParams()
    },
  },
}
</script>

<style lang="scss" scoped>

@import "@/assets/scss-v2/variables.scss";
.hidden-report {
  @apply hidden;
}

.md-hidden-report {
  @apply md:hidden;
}

.md-flex {
  @apply md:flex;
}

.wrapper-report{
  padding: 24px 40px 120px 40px;
  @media (max-width: 1024px) {
    padding: 24px 1rem 90px 1rem;
  }
}
.wrapper-toolbox{
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
}
.aha-button-base{
  background: white;
}
.base-color{
  color:#525F7F;
}
.section-info-presentation {
  display: flex;
  gap: 1rem;

  font-size: 16px;
  .text-reaction{
    font-size: 16px;
  }
}
.info-section {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  border-radius: 0.5rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(12, 1fr);
    background-color: white;
    padding: 0.75rem;
  }

  .overal-report-section {
    --metric-box-height-desktop: 116px;
    --metric-box-height-tablet: 134px;
    padding: 0.5rem;
    background-color: white;
    display: grid;
    border-radius: 0.5rem;

    @media (min-width: 768px) {
      padding: 0px;
      background-color: transparent;
      grid-column: 1 / 7;
      gap: 0.75rem;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: max-content;
    }

    @media (min-width: 1024px) {
      grid-column: 1 / 9;
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: minmax(var(--metric-box-height-desktop), max-content);
    }

    @media (min-width: 1366px) {
    }

    & .metric-box {
      border-radius: none;
      padding: 0.5rem;
      gap: 0.75rem;

       & .text-metric {
        font-size: 16px;
       }

       & .text-explain-metric {
        font-size: 14px;
       }

      @media (min-width: 768px) {
        & .text-metric {
          font-size: 20px;
        }

        & .text-explain-metric {
          font-size: 14px;
        }
        padding: 0.75rem;
        flex-direction: column;
        align-items: start;

        & img {
          width: 52px;
        }

        & > div {
          padding: 0;
        }
      }

      @media (min-width: 1366px) {
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .preview-section {
    border-radius: 0.5rem;
    background-color: white;

    @media (min-width: 768px) {
      grid-column: 7 / 13;

      & .sharing-view {
        background-color: #F0F4FA;
        border: #F0F4FA 2px solid;
        border-radius: 0.5rem;
      }
    }

    @media (min-width: 1024px) {
      grid-column: 9 / 13;
    }
  }
}

.wrapper-table{
  @apply bg-base-0 gap-4  rounded-md;
}
.title-tab {
  padding: 16px 24px 0px 24px;
  border-bottom: 1px solid #ddd;

  a {
    display: inline-block;
    padding: 0 16px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding-bottom: 10px;
    margin-bottom: -1px;

    &.active {
      border-bottom: 3px solid #6A1EBB;
      color: #6A1EBB;
    }
  }
}

.report-panel {
  @apply bg-base-0 w-full p-4 pb-40 transition-all shadow-top bg-no-repeat;
  @apply right-0 overflow-y-scroll;
  @apply h-full fixed;
  @apply top-16;
  background-size: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* Hide scrollbar on IE and Edge */
  scrollbar-width: none;

  .report-panel-export {
    display: block;
  }

  &.in-editor {
    width: 100%;
    .report-panel-export {
      display: none;
    }
  }

  @media (min-width: 768px) { // sm screens
    min-height: calc(100vh - 4rem); // header height is 4rem
    width: 354px;
    &.in-editor {
      width: $rightSideWidth;
      @apply top-32;
    }
  }
}
.body-table{
  height: 400px;
  overflow-y: scroll;
  -ms-overflow-style: auto;
}

.report-engagement-rate {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px rgba(211, 215, 225, 0.65);
  border-radius: 8px;
}

.nav-tabs {
  display: flex;
  margin-left: -1rem;
  margin-right: -1rem;
  border-top: 1px solid #EBEBEB;

  .nav-item {
    @apply bg-secondary-15 text-center text-secondary-40 cursor-pointer;
    @apply flex justify-center items-center flex-1;
    padding: 14px;

    &.active {
      @apply bg-base-0;
      color: #191F2D;
    }
  }
}
.metric-box {
  cursor: pointer;

  &.cursor-auto {
    cursor: auto;
  }
  svg {
    width: 48px;
    height: 48px;

    @media (min-width: 768px) {
      width: 52px;
      height: 52px;
    }

    &:nth-child(1) {
      display: inline-block;
    }

    &:nth-child(2) {
      display: none;
    }
  }
  height:100%;
  align-items: center;
  @apply bg-base-0 gap-4 rounded-md flex flex-row;
  .text-metric{
    font-size: 20px;
    // bold
    font-weight: bold;
  }
  .text-explain-metric{
    font-size: 16px;
  }

  &:hover {
    background-color: #F0F4FAB2;

    & svg {
      &:nth-child(1) {
        display: none;
      }

      &:nth-child(2) {
        display: inline-block;
      }
    }
  }
}
.content__mobile-screen {
  @apply sm:mt-20 mt-12;
  display: none;

  text-align: center;
  @media (max-width:  1024px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}
.header{
  svg{
    cursor: pointer;
  }
}
.modal__title--tab {
  padding: 0 16px;
  border-bottom: 1px solid #ddd;

  a {
    display: inline-block;
    padding: 0 16px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    padding-bottom: 10px;
    margin-bottom: -1px;

    &.active {
      border-bottom: 3px solid #6A1EBB;
      color: #6A1EBB;
    }
  }
  &.title-tab__content-wrapper {
    @apply flex overflow-x-auto overflow-y-hidden;
    padding: 16px 16px 0 16px;
  }
  .title-tab__content {
    @apply flex;
  }
}
</style>
